import React from 'react';
import { reportErrorToNewRelic } from 'src/scripts/utils/helpers';
import { notNil } from 'src/scripts/utils/typescriptUtils';
import { ProductCards } from '../../product-listing-page/components/PlpTiles';
import productServiceProductToProductNode from '../../_shared/wishlist/productServiceToProductNode';
import { WishListTypes } from '../../_shared/wishlist/wishlist-types';

export default function Wishlist({ wishlistData }: { wishlistData: WishListTypes[] }) {
  const productNodes = wishlistData
    .map((wishlistItem) => wishlistItem.product_service)
    .filter((i) => i) // remove undefined items
    .map((productServiceProduct, index) => {
      try {
        return productServiceProductToProductNode(productServiceProduct!);
      } catch (e) {
        console.error(e);
        reportErrorToNewRelic(
          new Error(`Error converting productServiceProductToProductNode for: ${productServiceProduct?.gid}`)
        );
        return null;
      }
    })
    .filter(notNil);

  return (
    <>
      <div className="product-cards">
        <ProductCards
          filteredProducts={productNodes}
          collectionHandle={'wishlist'}
          collectionShopifyId={''}
          products={productNodes}
          hasAFilterSelected={false}
          source="Wishlist"
        />
      </div>
    </>
  );
}
